import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {TylerMatTableDataSource} from '../../../shared-components/angular-material/extended.class';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
    selector: 'app-view-recipients-modal',
    templateUrl: './view-recipients-modal.component.html',
    styleUrls: ['./view-recipients-modal.component.css']
})
export class ViewRecipientsModalComponent implements OnInit {

    angularMatData = new TylerMatTableDataSource();
    displayedColumns: string[] = ['name', 'type', 'email'];
    includeTeachers = false;
    includeTeamStaffMembers = false;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    v10: boolean;
    constructor(
        private dialogRef: MatDialogRef<ViewRecipientsModalComponent>, 
        @Inject(MAT_DIALOG_DATA) private data: any,
        private loginService: LoginService
        ) {
        this.v10 = this.loginService.LoginSettings.V10;
    }

    ngOnInit() {
        if (this.data) {
            this.angularMatData.data = this.data.recipients;
            this.angularMatData.sort = this.sort;
            this.includeTeachers = this.data.includeTeachers;
            this.includeTeamStaffMembers = this.data.includeTeamStaffMembers;
        }
        this.v10 = this.loginService.LoginSettings.V10;
    }

    closeClick() {
        this.dialogRef.close();
    }
}
